<template>
  <div id="description" class="text-left">
    <span
      class="text"
      v-html="
        htmlPersonalization
          ? completeText
            ? text
            : shortText
          : formatText(completeText ? text : shortText)
      "
    >
    </span>
    <button
      v-if="textSize > maxWords"
      class="text-color-topaz-light"
      @click="showMoreAction"
    >
      {{ completeText ? $t("wegow.showLess") : $t("wegow.showMore") }}
    </button>
  </div>
</template>
<script setup>
import { toRefs, computed, ref } from "vue";

const props = defineProps({
  type: {
    type: String,
    default: undefined
  },
  text: {
    type: String,
    default: undefined
  },
  maxWords: {
    type: Number,
    default: 80
  },
  htmlPersonalization: {
    type: Boolean,
    default: false
  }
});
const { type, text, maxWords } = toRefs(props);

const completeText = ref(false);
const textSize = computed(() => text.value?.split(" ").length);
const shortText = computed(() => {
  const wordsList = text.value?.split(" ");

  return textSize.value > maxWords.value
    ? wordsList.splice(0, maxWords.value).join(" ") + "..."
    : text.value;
});

const showMoreAction = () => {
  completeText.value = !completeText.value;
  if (!completeText.value) {
    const description = document.getElementById("description");
    description.scrollIntoView({ behavior: "smooth" });
  }
};

const formatText = text => {
  return text?.replace(/\n/g, "<br>");
};
</script>
